export const MAP_SELECTED_METRIC_VALUES_STORAGE_KEY = 'mapSelectedMetricValues'
export const CORE_MAP_METRIC_VALUE = 'temperature'

export const MAP_METRIC_OPTIONS = [
  { value: 'sigmaw10', label: 'Hazardous Inversion', metric_decimal_places_key: 'sigmaw_map' },
  { value: 'ann_2hr_sigma_w', label: '2hr Predict: Hazardous Inversion', metric_decimal_places_key: 'ann_2hr_sigma_w' },
  { value: 'ghcop', label: 'Grain Harvest Code of Practice (GHCoP, wind@2m)', metric_decimal_places_key: 'ghcop' },
  { value: 'vtd', label: 'Inversion: VTD', metric_decimal_places_key: 'vtd' },
  { value: 'temperature', label: 'Temperature - 1.2m', metric_decimal_places_key: 'temperature' },
  { value: 'temperature_max_today', label: 'Temperature - maximum today', metric_decimal_places_key: 'temperature' },
  { value: 'temperature_min_today', label: 'Temperature - minimum today', metric_decimal_places_key: 'temperature' },
  { value: 'relative_humidity', label: 'Relative Humidity - 1.2m', metric_decimal_places_key: 'relative_humidity' },
  { value: 'delta_t', label: 'Delta T', metric_decimal_places_key: 'delta_t' },
  { value: 'wind_speed_2m', label: 'Wind Speed - 2m', metric_decimal_places_key: 'wind_speed' },
  { value: 'wind_speed_10m', label: 'Wind Speed - 10m', metric_decimal_places_key: 'wind_speed' },
  { value: 'dew_point', label: 'Dew Point', metric_decimal_places_key: 'wind_speed' },
  { value: 'rainfall_last_hour', label: 'Rainfall in last hour', metric_decimal_places_key: 'rainfall' },
  { value: 'current_day_rainfall', label: 'Rainfall since 9am', metric_decimal_places_key: 'rainfall' },
  { value: 'previous_day_rainfall', label: 'Rainfall 24h to 9am', metric_decimal_places_key: 'rainfall' },
  { value: 'rainfall_month', label: 'Rainfall this month', metric_decimal_places_key: 'rainfall' },
  { value: 'rainfall_year', label: 'Rainfall this year', metric_decimal_places_key: 'rainfall' },
  { value: 'solar_radiation', label: 'Solar Radiation', metric_decimal_places_key: 'temperature' },
  { value: 'gfdi', label: 'GFDI (wind@10m)', metric_decimal_places_key: 'gfdi' },
  { value: 'evapotranspiration', label: 'Evapotranspiration', metric_decimal_places_key: 'evapotranspiration_map' },
  { value: 'thermal_time', label: 'Thermal Time since May 1', metric_decimal_places_key: 'thermal_vernalisation_time_map' },
  { value: 'vernalisation_time', label: 'Vernalisation Time since May 1', metric_decimal_places_key: 'thermal_vernalisation_time_map' },
  { value: 'adjusted_thermal_time', label: 'Adjusted Thermal Time since May 1', metric_decimal_places_key: 'thermal_vernalisation_time_map' },
  { value: 'downy_mildew', label: 'Downy Mildew Risk' },
  { value: 'etiella', label: 'Etiella Susceptibility', metric_decimal_places_key: 'temperature' },
  { value: 'rlem', label: 'RLEM Susceptibility' },
  { value: 'ag360_flystrike', label: 'Flystrike Risk (5 day)' },
  { value: 'ag360_heat_chill_risk', label: 'Heat/Chill Risk (5 day)' },
  { value: 'cci', label: 'Animal Comfort Index', metric_decimal_places_key: 'cci_map' },
]

export const MAP_METRIC_CATEGORIES = [
  { id: 'spray', label: 'Spray', metricValues: ['sigmaw10', 'ann_2hr_sigma_w', 'vtd', 'relative_humidity', 'delta_t', 'wind_speed_2m', 'wind_speed_10m'] },
  { id: 'harvest', label: 'Harvest', metricValues: ['ghcop', 'relative_humidity', 'wind_speed_2m', 'wind_speed_10m', 'dew_point', 'delta_t', 'gfdi'] },
  { id: 'rainfall', label: 'Rainfall', metricValues: ['rainfall_last_hour', 'current_day_rainfall', 'previous_day_rainfall', 'rainfall_month', 'rainfall_year'] },
  { id: 'livestock', label: 'Livestock', metricValues: ['ag360_flystrike', 'ag360_heat_chill_risk', 'cci'] },
  { id: 'general', label: 'General', metricValues: ['temperature_max_today', 'temperature_min_today', 'relative_humidity', 'delta_t', 'wind_speed_2m', 'wind_speed_10m', 'dew_point', 'gfdi', 'ghcop', 'solar_radiation', 'evapotranspiration'] },
  { id: 'crop_science', label: 'Crop Science', metricValues: ['thermal_time', 'vernalisation_time', 'adjusted_thermal_time'] },
  { id: 'crop_risk', label: 'Crop Risk', metricValues: ['downy_mildew', 'etiella', 'rlem'] },
]

const OPTIONAL_MAP_METRIC_OPTIONS = MAP_METRIC_OPTIONS
  .filter(({ value }) => value !== CORE_MAP_METRIC_VALUE)

const OPTIONAL_MAP_METRIC_VALUES = OPTIONAL_MAP_METRIC_OPTIONS
  .map(({ value }) => value)

const OPTIONAL_MAP_METRIC_VALUE_SET = new Set(OPTIONAL_MAP_METRIC_VALUES)

export const getDefaultSelectedMapMetricValues = () => OPTIONAL_MAP_METRIC_VALUES.slice()

export const validateSavedMapMetricValues = (metricValues) => {
  if (!Array.isArray(metricValues)) return []

  const seenMetricValues = new Set()

  return metricValues.filter((value) => {
    if (!OPTIONAL_MAP_METRIC_VALUE_SET.has(value) || seenMetricValues.has(value)) return false
    seenMetricValues.add(value)
    return true
  })
}

export const getSelectedMapMetricValuesFromSavedPreferences = (savedPreferences) => {
  if (!savedPreferences || Array.isArray(savedPreferences) || typeof savedPreferences !== 'object') {
    return getDefaultSelectedMapMetricValues()
  }

  return OPTIONAL_MAP_METRIC_OPTIONS
    .filter(({ value }) => {
      if (!Object.prototype.hasOwnProperty.call(savedPreferences, value)) return true
      return savedPreferences[value] === true
    })
    .map(({ value }) => value)
}

export const buildSavedMapMetricPreferences = (selectedMetricValues) => {
  const selectedMetricValueSet = new Set(validateSavedMapMetricValues(selectedMetricValues))

  return OPTIONAL_MAP_METRIC_OPTIONS.reduce((memo, { value }) => {
    memo[value] = selectedMetricValueSet.has(value)
    return memo
  }, {})
}

export const buildAvailableMapMetricOptions = (selectedMetricValues) => {
  const selectedMetricValueSet = new Set([
    CORE_MAP_METRIC_VALUE,
    ...validateSavedMapMetricValues(selectedMetricValues),
  ])

  return MAP_METRIC_OPTIONS.filter(({ value }) => selectedMetricValueSet.has(value))
}

export const getMapMetricCategorySelectionState = (categoryMetricValues, selectedMetricValues) => {
  const optionalCategoryMetricValues = categoryMetricValues.filter((value) => value !== CORE_MAP_METRIC_VALUE)
  const selectedMetricValueSet = new Set(validateSavedMapMetricValues(selectedMetricValues))
  const selectedCount = optionalCategoryMetricValues.filter((value) => selectedMetricValueSet.has(value)).length
  const totalCount = optionalCategoryMetricValues.length

  return {
    checked: totalCount > 0 && selectedCount === totalCount,
    indeterminate: selectedCount > 0 && selectedCount < totalCount,
  }
}
